module.exports = function() {
  return new Worker(__webpack_public_path__ + "013bd007de360ddb5eef.worker.js");
};